import React from 'react';
import  "./Footer.css";

function Footer() {
  return (
    <div>  
    <footer>
      <p>&copy; 2025 Finney Properties, LLC. </p>
      <p>
        Powered by{" "}
        <a href="https://www.agilelabs.ai" target="_blank" rel="noopener noreferrer">
          agilelabs.ai
        </a>
      </p>
    </footer></div>
  )
}

export default Footer